// src/resources/rdf/RdfShow.js
import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    TopToolbar,
    FunctionField,
} from 'react-admin';
import ValidateButton from './ValidateButton';
import ValidateWithTermsButton from './ValidateWithTermsButton';
import RejectButton from './RejectButton';
import StatusField from '../../components/StatusField';

const describeVariantType = (label, code) => label || code || 'Variante';

const renderTermDetails = (record, {
    baseKey,
    usesVariantKey,
    typeLabelKey,
    typeCodeKey,
    baseStatusKey,
    variantStatusKey,
}) => {
    if (!record) return '—';

    const base = record[baseKey] ?? '—';
    const usesVariant = record[usesVariantKey];

    if (usesVariant === undefined || usesVariant === null) {
        return base;
    }

    const baseStatus = baseStatusKey ? record[baseStatusKey] : null;
    const variantStatus = variantStatusKey ? record[variantStatusKey] : null;
    const status = usesVariant ? variantStatus || baseStatus : baseStatus;
    const statusSegment = status ? ` · Statut : ${status}` : '';

    if (!usesVariant) {
        return `${base} (Nu${statusSegment})`;
    }

    const type = describeVariantType(record[typeLabelKey], record[typeCodeKey]);
    return `${base} (Variante : ${type}${statusSegment})`;
};

export default function RdfShow() {
    return (
        <Show
            actions={
                <TopToolbar>
                    <ValidateButton />
                    <ValidateWithTermsButton />
                    <RejectButton />
                </TopToolbar>
            }
        >
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="rdfId" />
                <FunctionField
                    label="Subject"
                    render={(record) =>
                        renderTermDetails(record, {
                            baseKey: 'subject',
                            usesVariantKey: 'subjectUsesVariant',
                            typeLabelKey: 'subjectVariantTypeLabel',
                            typeCodeKey: 'subjectVariantType',
                            baseStatusKey: 'subjectStatus',
                            variantStatusKey: 'subjectVariantStatus',
                        })
                    }
                />
                <TextField source="predicate" />
                <FunctionField
                    label="Object"
                    render={(record) =>
                        renderTermDetails(record, {
                            baseKey: 'oobject',
                            usesVariantKey: 'oobjectUsesVariant',
                            typeLabelKey: 'oobjectVariantTypeLabel',
                            typeCodeKey: 'oobjectVariantType',
                            baseStatusKey: 'oobjectStatus',
                            variantStatusKey: 'oobjectVariantStatus',
                        })
                    }
                />
                <TextField source="username" />
                <TextField source="witWik" />

                {/* Chip de statut */}
                <StatusField />

                <DateField source="createdAt" showTime />

                <DateField source="validatedAt" showTime />
                <TextField source="validatedBy" />

                <DateField source="rejectedAt" showTime />
                <TextField source="rejectedBy" />
            </SimpleShowLayout>
        </Show>
    );
}
